import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import MDTypography from 'components/MDTypography';
import {
  AttendanceNotesList,
  AttendanceNotesTitle,
  AttendanceNotesWrapper,
} from 'layouts/applications/attendance/Attendance.styled';
import {
  SsaEmptyStateBox,
  NotesHistoryTypography,
} from '../ssaProfileTabComponent/service/SsaProfileTabStyled';
import { NotesTypography } from 'layouts/inventory/Inventory.styled';

/* ------------------ Info Row ------------------ */
export const InfoRow = ({ label, value }) => (
  <AttendanceNotesList>
    <AttendanceNotesTitle variant="h6">{label}:</AttendanceNotesTitle>
    <NotesTypography variant="h6">{value || '-'}</NotesTypography>
  </AttendanceNotesList>
);

/* ------------------ Notes History ------------------ */
export const NotesHistoryList = ({ noteHistory }) => {
  if (!Array.isArray(noteHistory) || noteHistory.length === 0) {
    return <NotesHistoryTypography variant="h6">-</NotesHistoryTypography>;
  }

  return (
    <>
      {noteHistory.map((item, index) => (
        <NotesHistoryTypography key={index} variant="h6">
          • {JSON.stringify(item)}
        </NotesHistoryTypography>
      ))}
    </>
  );
};

/* ------------------ Empty State ------------------ */
export const EmptyState = ({ message = 'No records found' }) => (
  <SsaEmptyStateBox>
    <MDBox sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <MDTypography variant="body2" fontWeight="medium">
        {message}
      </MDTypography>
    </MDBox>
  </SsaEmptyStateBox>
);

export const PreviousWeekNoteItem = ({ item }) => {
  const { id, addedAt, week, label, note, noteHistory } = item;

  return (
    <AttendanceNotesWrapper container key={id || addedAt}>
      <Grid item xs={12}>
        <InfoRow label="Week" value={week} />
        <InfoRow label="Status" value={label} />
        <InfoRow label="Note" value={note} />

        <AttendanceNotesTitle variant="h6">History:</AttendanceNotesTitle>

        <MDBox sx={{ pl: 2 }}>
          <NotesHistoryList noteHistory={noteHistory} />
        </MDBox>
      </Grid>
    </AttendanceNotesWrapper>
  );
};
